module.exports = __webpack_public_path__ + "assets/img/3.7c3eaf4b.jpg";